import * as yup from "yup";

export const VideoGalleryValidation = yup.object().shape({
    sanstha_id: yup.object().required("Required"),
    url: yup.string().required("Required"),
});